import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { AccountUnderlyingModel } from 'src/app/model/account-underlying.model';

export const RequestAction = createAction('[Account balance view] get data', props<{ accountId: number }>());
export const ResponseAction = createAction('[Account balance view] set data', props<{ payload: AccountUnderlyingModel }>());

